'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _input = require('../input');
var _input2 = _interopRequireDefault(_input);
var _withFormId = require('../../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _formField = require('../form-field');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ManualWrapper = (0, _glamorous2.default)('div')(_formField.formFieldStyles);
var Manual = function (_Component) {
  _inherits(Manual, _Component);
  function Manual() {
    _classCallCheck(this, Manual);
    return _possibleConstructorReturn(this, (Manual.__proto__ || Object.getPrototypeOf(Manual)).apply(this, arguments));
  }
  _createClass(Manual, [{
    key: 'render',
    value: function render() {
      var fieldNames = this.props.fieldNames;
      return _react2.default.createElement(ManualWrapper, null, _react2.default.createElement('fieldset', {
        style: {
          border: 'unset',
          padding: 'unset',
          margin: 'unset'
        }
      }, _react2.default.createElement('legend', {
        style: {
          fontWeight: 700
        }
      }, this.props.label), _react2.default.createElement(_input2.default, {
        name: fieldNames.Line1,
        label: 'Address line 1'
      }), _react2.default.createElement(_input2.default, {
        name: fieldNames.Line2,
        label: 'Line 2'
      }), _react2.default.createElement(_input2.default, {
        name: fieldNames.TownCity,
        label: 'Town/city'
      }), _react2.default.createElement(_input2.default, {
        name: fieldNames.County,
        label: 'County'
      }), _react2.default.createElement(_input2.default, {
        name: fieldNames.Postcode,
        format: ['alpha-int', 'uppercase', 'no-spaces'],
        label: 'Postcode',
        maxLength: '8',
        extra: _react2.default.createElement('a', {
          onClick: this.props.clearAddress
        }, 'Try another lookup')
      })));
    }
  }]);
  return Manual;
}(_react.Component);
Manual.propTypes = {
  // props
  name: _propTypes.string.isRequired,
  clearAddress: _propTypes.func.isRequired,
  fieldNames: _propTypes.object.isRequired
};
exports.default = (0, _withFormId2.default)(Manual);